namespace GeniuzPOS.ReportMasterData {
    export class Report_1311Columns {
        static columnsKey = 'ReportMasterData.Report_1311';
    }
}
